// QuoteTimeline.jsx
import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import { format, parseISO, differenceInMinutes } from 'date-fns';
import './QuoteTimeline.css';

const getDeltaLabel = (mins) => {
    if (mins >= 1440) return `+${Math.floor(mins / 1440)}d`;
    if (mins >= 60) return `+${Math.floor(mins / 60)}h`;
    return `+${mins}m`;
};

const QuoteTimeline = ({ logs = [] }) => {
    if (!logs.length) return <div>No logs available</div>;

    const sortedLogs = [...logs].sort((a, b) => new Date(a.date) - new Date(b.date));
    const firstDate = parseISO(sortedLogs[0].date);

    return (
        <div style={{ marginTop: 10 }}>
            <strong>Status Changes:</strong>
            <Stepper alternativeLabel activeStep={sortedLogs.length - 1} sx={{ padding: '20px 0' }}>
                {sortedLogs.map((log, index) => {
                    const currentDate = parseISO(log.date);
                    const time = format(currentDate, 'dd MMM HH:mm');

                    const sinceLast =
                        index > 0
                            ? differenceInMinutes(currentDate, parseISO(sortedLogs[index - 1].date))
                            : 0;

                    const sinceFirst = index > 0 ? differenceInMinutes(currentDate, firstDate) : 0;

                    return (
                        <Step key={index}>
                            <StepLabel
                                StepIconProps={{ style: { color: '#90caf9' } }}
                            >
                                <div style={{ fontSize: '0.75rem', textAlign: 'center', color: '#e0e0e0' }}>
                                    <div>{log.type}</div>
                                    <div>{time}</div>
                                    <div style={{ color: '#bdbdbd' }}>{getDeltaLabel(sinceLast)}</div>
                                    {index > 0 && (
                                        <div style={{ color: '#42a5f5' }}>{getDeltaLabel(sinceFirst)}</div>
                                    )}
                                </div>
                            </StepLabel>

                        </Step>
                    );
                })}
            </Stepper>
        </div>
    );
};

export default QuoteTimeline;
